<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Daily Sales Summary Report") }}</div>

      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="getDailyReportFromDate" @click.prevent="
                  onDailyReportDateHandler({ event: null, name: 'fromDate' })
                  ">
                  ✖
                </button>
                <Datepicker :monday-first="true" ref="programaticOpen" :value="getDailyReportFromDate" typeable
                  @selected="
                    onDailyReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                    " v-validate="'required'"></Datepicker>
                <label :class="getDailyReportFromDate ? 'active' : ''">{{ $t("transactions") }} {{ $t("date") }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="getDailyReportToDate" v-on:click="
                  onDailyReportDateHandler({ event: null, name: 'toDate' })
                  ">
                  ✖
                </button>
                <Datepicker :monday-first="true" @selected="
                  onDailyReportDateHandler({ event: $event, name: 'toDate' })
                  " :value="getDailyReportToDate" ref="programaticOpen" v-validate="'required'"></Datepicker>
                <label :class="getDailyReportToDate ? 'active' : ''">End Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label :class="getDailyReportSelectedCinema &&
                  getDailyReportSelectedCinema.length > 0
                  ? 'shift-up'
                  : ''
                ">{{ $tc("cinema", 1) }}</label>
              <b-dropdown :text="getDailyReportSelectedCinema" variant="dropdown-curve" class="w-100"
                :disabled="isRoleID">
                <div class="px-2 pb-2">
                  <input required autofocus type="search" :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm" v-on:keyup="onSearchCinema()" v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()" v-model="searchCinema" />
                </div>
                <b-dropdown-item v-for="(dropdownItem, dropdownIndex) in Cinemas" :key="dropdownIndex" @click="
                  onDailyReportDropdownHandler({
                    event: $event,
                    name: 'Cinema',
                    selectedItem: dropdownItem,
                    index: dropdownIndex,
                  });
                searchCinema = '';
                onSearchCinema();
                onSelectCinema(dropdownItem);
                ">{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label :class="getDailyReportSelectedPosUser &&
                  getDailyReportSelectedPosUser.length > 0
                  ? 'shift-up'
                  : 'd-none'
                ">{{ $tc("user", 1) }}</label>
              <!-- <b-dropdown
                :text="getDailyReportSelectedPosUser"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getPosUsersList"
                  :key="dropdownIndex"
                  @click="onDailyReportDropdownHandler({ event: $event, name:'PosUser',selectedItem: dropdownItem, index:dropdownIndex })"
                >
                  <span>{{ dropdownItem.user_id ? `${dropdownItem.first_name} ${dropdownItem.middle_name } ${ dropdownItem.last_name }`: 'All' }}</span>
                </b-dropdown-item>
              </b-dropdown>-->
              <multiselect :options="getPosUsersList" :searchable="true" :placeholder="getDailyReportSelectedPosUser &&
                  getDailyReportSelectedPosUser.length > 0
                  ? getDailyReportSelectedPosUser
                  : 'User'
                " :customLabel="setLabel" track-by="user_id" @select="
                  onDailyReportDropdownHandler({
                    event: $event,
                    name: 'PosUser',
                    selectedItem: $event,
                  })
                  " :allowEmpty="false" :showLabels="false"></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container mr-2">
              <label :class="getDailyReportSelectedPaymentMode &&
                  getDailyReportSelectedPaymentMode.length > 0
                  ? 'shift-up'
                  : ''
                ">{{ $t("paymentmode") }}</label>
              <b-dropdown :text="getDailyReportSelectedPaymentMode" variant="dropdown-curve" class="w-100">
                <b-dropdown-item v-for="(dropdownItem, dropdownIndex) in getPaymentTypesList" :key="dropdownIndex"
                  @click="
                    onDailyReportDropdownHandler({
                      event: $event,
                      name: 'PaymentMode',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                    ">{{ dropdownItem.pm_payment_mode }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onFetchReport()">
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>
          <div v-if="
            getDailyReportList.length > 0 ||
            // getDailyConcessionReportList.length > 0 ||
            getConcessionDailyReportData.length > 0
          " class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center">
            <div v-if="
              getDailyReportList.length > 0 ||
              // getDailyConcessionReportList.length > 0 ||
              getConcessionDailyReportData.length > 0
            ">{{ $t("download") }} as:</div>
            <a v-if="getDailyPDFFileName" :href="BASE_URL + getDailyPDFFileName" target="_blank" download
              title="Download as PDF">
              <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
            </a>
            <a v-if="getDailyExcelFileName" :href="BASE_URL + getDailyExcelFileName" target="_blank"
              title="Download as Excel" download>
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
          <div class="col-md-3 align-self-center">
            <!-- <b-dropdown id="listview" variant="outline-blue-lg">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
<b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex" @click="onDropDownChangeValue(list.name)"
  href="#">{{list.name}}</b-dropdown-item>
</b-dropdown>-->
          </div>
        </div>
      </div>

      <div class="swc-report">
        <!-- <div
          v-if="
            getDailyReportList.length > 0 ||
              getSaleCashCard.length > 0 ||
              getTopUpCashCard.length > 0 ||
              getDailyConcessionReportList.length > 0 ||
              getConcessionDailyReportData.length > 0
          "
          class="d-flex justify-content-end  align-items-center"
        >
          {{ $t("download") }} as:
          <a
            v-if="getDailyPDFFileName"
            :href="BASE_URL + getDailyPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a
            v-if="getDailyExcelFileName"
            :href="BASE_URL + getDailyExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->

        <table class="swc-report-table dailysales_report" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th class="bg-lightgrey text-left">{{ "Channel" }}</th>
              <th class="bg-lightgrey text-left">{{ "User" }}</th>
              <th class="bg-lightgrey text-left">{{ "Location" }}</th>
              <th class="bg-lightgrey text-left">
                {{ "PayType" }}
              </th>
              <th class="bg-lightgrey text-left">
                {{ "Vouchers" }}
              </th>
              <th class="bg-lightgrey text-right">
                {{ "No. Of Ticket" }}
              </th>
              <th class="bg-lightgrey text-right">
                {{ "Cash" }}
              </th>
              <th class="bg-lightgrey text-right">
                {{ "Others" }}
              </th>
              <th class="bg-lightgrey text-right">{{ "Voucher Amt." }}</th>
              <th class="bg-lightgrey text-right">
                {{ $t("CashCard") }}
              </th>
              <th class="bg-lightgrey text-right">
                {{ "Total Sales" }}
              </th>
              <!-- <th class="bg-lightgrey">{{ $t("net") }} {{ $t("revenue") }}</th> -->
              <th class="bg-lightgrey text-right">
                <span class="fs-12">{{ "Total Sales" }}</span> <br />
                <span class="fs-10 text-truncate">{{ "(Less discount)" }}</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="
            getDailyReportList.length === 0 &&
            getDailyConcessionReportList.length === 0
          ">
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody v-for="(dailyReportItem,
            dailyReportItemIndex) in getDailyReportList" :key="dailyReportItemIndex">
            <tr>
              <td rowspan="50" style="text-align: left">
                <strong>{{ dailyReportItem.Data[0].bs_source }}</strong>
              </td>
            </tr>

            <tr>
              <td rowspan="50" class="text-left">
                <strong>{{ dailyReportItem.Data[0].booking_user_name }} <br />({{
                  dailyReportItem.Data[0].up_employee_code
                }})</strong>
              </td>
              <!-- <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> -->
            </tr>
            <tr style="background-color: rgba(169, 217, 251, 0.5)">
              <td class="text-left">
                <strong>{{ dailyReportItem.Data[0].bs_source }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(paymentMode, paymentModeIndex) in dailyReportItem.Data"
              :key="paymentModeIndex + paymentMode.tickets">
              <td></td>
              <td class="text-left">{{ paymentMode.payment_mode }}</td>
              <td class="text-left">
                {{
                  paymentMode.offer_name != "" && paymentMode.offer_name != null
                    ? paymentMode.offer_name
                    : paymentMode.voucher_name != "" &&
                      paymentMode.voucher_name != null
                      ? paymentMode.voucher_name
                      : ""
                }}
              </td>
              <td class="text-right">{{ paymentMode.tickets }}</td>
              <td class="text-right">
                {{ currFormat(paymentMode.cash_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(paymentMode.payment_mode_amount) }}
              </td>
              <td class="text-right">{{ currFormat(paymentMode.discount) }}</td>
              <td class="text-right">
                {{ currFormat(paymentMode.cash_card_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(paymentMode.gross_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(paymentMode.gross_revenue) }}
              </td>
            </tr>

            <tr style="background-color: rgba(211, 211, 211, 0.4)">
              <td class="text-left">
                <strong>{{ dailyReportItem.Data[0].bs_source }}
                  {{ $t("total") }}</strong>
              </td>
              <td></td>

              <td>
                <!-- <strong>{{ dailyReportItem.payments.reduce(function(accumulator, { total_seats }) { return accumulator + parseFloat(total_seats); },0) }}</strong> -->
              </td>
              <td class="text-right">
                <!-- <strong>2.00</strong> -->
                <strong>{{
                  dailyReportItem.Data.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                    0)
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { cash_amount }
                    ) {
                      return accumulator + parseFloat(cash_amount);
                    },
                      0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { payment_mode_amount }
                    ) {
                      return accumulator + parseFloat(payment_mode_amount);
                    },
                      0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                      0)
                  )
                }}</strong>
                <!-- <strong>3.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { cash_card_amount }
                    ) {
                      return accumulator + parseFloat(cash_card_amount);
                    },
                      0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                      0)
                  )
                }}</strong>
                <!-- <strong>0.00</strong> -->
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.Data.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                      0)
                  )
                }}</strong>
              </td>
            </tr>
            <tr v-if="dailyReportItem.DataRefund" style="background-color: rgba(246, 194, 188, 0.5)">
              <td class="text-left">
                <strong>{{ $tc("refund", 1) }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-else></tr>

            <tr v-for="(paymentMode1,
              paymentMode1Index) in dailyReportItem.DataRefund" :key="paymentMode1Index + paymentMode1.payment_mode">
              <td></td>
              <td class="text-left">{{ paymentMode1.payment_mode }}</td>
              <td class="text-left">
                {{
                  paymentMode1.offer_name != "" || null
                    ? paymentMode1.offer_name
                    : paymentMode1.voucher_name != "" || null
                      ? paymentMode1.voucher_name
                      : ""
                }}
              </td>
              <td class="text-right">-{{ paymentMode1.tickets }}</td>
              <td class="text-right">
                {{
                  currFormat(paymentMode1.cash_amount_refund) > 0
                    ? "-" + currFormat(paymentMode1.cash_amount_refund)
                    : currFormat(paymentMode1.cash_amount_refund)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(paymentMode1.payment_mode_amount_refund) > 0
                    ? "-" + currFormat(paymentMode1.payment_mode_amount_refund)
                    : currFormat(paymentMode1.payment_mode_amount_refund)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(paymentMode1.discount) > 0
                    ? "-" + currFormat(paymentMode1.discount)
                    : currFormat(paymentMode1.discount)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(paymentMode1.cash_card_refund) > 0
                    ? "-" + currFormat(paymentMode1.cash_card_refund)
                    : currFormat(paymentMode1.cash_card_refund)
                }}
              </td>
              <td class="text-right">
                {{
                  currFormat(paymentMode1.gross_amount) > 0
                    ? "-" + currFormat(paymentMode1.gross_amount)
                    : currFormat(paymentMode1.gross_amount)
                }}
              </td>
              <!-- <td class="text-right">{{ currFormat(paymentMode1.net_revenue) }}</td> -->
              <td class="text-right">
                {{
                  currFormat(paymentMode1.gross_revenue) > 0
                    ? "-" + currFormat(paymentMode1.gross_revenue)
                    : currFormat(paymentMode1.gross_revenue)
                }}
              </td>
            </tr>

            <tr v-if="dailyReportItem.DataRefund" style="background-color: rgba(211, 211, 211, 0.4)">
              <td class="text-left">
                <strong>{{ $tc("refund", 2) }} {{ $t("total") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td class="text-right">
                <strong>{{
                  dailyReportItem.DataRefund.reduce(function (
                    accumulator,
                    { tickets }
                  ) {
                    return accumulator + parseFloat(tickets);
                  },
                    0) > 0
                    ? "-" +
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                      0)
                    : dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                      0)
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { cash_amount_refund }
                    ) {
                      return accumulator + parseFloat(cash_amount_refund);
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { cash_amount_refund }
                      ) {
                        return accumulator + parseFloat(cash_amount_refund);
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { cash_amount_refund }
                      ) {
                        return accumulator + parseFloat(cash_amount_refund);
                      },
                        0)
                    )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { payment_mode_amount_refund }
                    ) {
                      return (
                        accumulator + parseFloat(payment_mode_amount_refund)
                      );
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { payment_mode_amount_refund }
                      ) {
                        return (
                          accumulator + parseFloat(payment_mode_amount_refund)
                        );
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { payment_mode_amount_refund }
                      ) {
                        return (
                          accumulator + parseFloat(payment_mode_amount_refund)
                        );
                      },
                        0)
                    )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { discount }
                    ) {
                      return accumulator + parseFloat(discount);
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { discount }
                      ) {
                        return accumulator + parseFloat(discount);
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { discount }
                      ) {
                        return accumulator + parseFloat(discount);
                      },
                        0)
                    )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { cash_card_refund }
                    ) {
                      return accumulator + parseFloat(cash_card_refund);
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { cash_card_refund }
                      ) {
                        return accumulator + parseFloat(cash_card_refund);
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { cash_card_refund }
                      ) {
                        return accumulator + parseFloat(cash_card_refund);
                      },
                        0)
                    )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { gross_amount }
                      ) {
                        return accumulator + parseFloat(gross_amount);
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { gross_amount }
                      ) {
                        return accumulator + parseFloat(gross_amount);
                      },
                        0)
                    )
                }}</strong>
              </td>
              <!-- <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                    0)
                  )
                }}</strong>
              </td> -->
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                      0)
                  ) > 0
                    ? "-" +
                    currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { gross_revenue }
                      ) {
                        return accumulator + parseFloat(gross_revenue);
                      },
                        0)
                    )
                    : currFormat(
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { gross_revenue }
                      ) {
                        return accumulator + parseFloat(gross_revenue);
                      },
                        0)
                    )
                }}</strong>
              </td>
            </tr>
            <tr v-else></tr>

            <tr>
              <td class="text-left">
                <strong>{{ dailyReportItem.Data[0].bs_source }} {{ $t("final") }}
                  {{ $t("total") }}</strong>
              </td>
              <td></td>
              <td></td>

              <td class="text-right">
                <strong>{{
                  dailyReportItem.DataRefund
                    ? dailyReportItem.Data.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                      0) -
                    dailyReportItem.DataRefund.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                      0)
                    : dailyReportItem.Data.reduce(function (
                      accumulator,
                      { tickets }
                    ) {
                      return accumulator + parseFloat(tickets);
                    },
                      0)
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? dailyReportItem.Data.reduce(function (
                        accumulator,
                        { cash_amount }
                      ) {
                        return accumulator + parseFloat(cash_amount);
                      },
                        0) -
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { cash_amount_refund }
                      ) {
                        return accumulator + parseFloat(cash_amount_refund);
                      },
                        0)
                      : dailyReportItem.Data.reduce(function (
                        accumulator,
                        { cash_amount }
                      ) {
                        return accumulator + parseFloat(cash_amount);
                      },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? dailyReportItem.Data.reduce(function (
                        accumulator,
                        { payment_mode_amount }
                      ) {
                        return accumulator + parseFloat(payment_mode_amount);
                      },
                        0) -
                      dailyReportItem.DataRefund.reduce(function (
                        accumulator,
                        { payment_mode_amount_refund }
                      ) {
                        return (
                          accumulator +
                          parseFloat(payment_mode_amount_refund)
                        );
                      },
                        0)
                      : dailyReportItem.Data.reduce(function (
                        accumulator,
                        { payment_mode_amount }
                      ) {
                        return accumulator + parseFloat(payment_mode_amount);
                      },
                        0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                          0) -
                        dailyReportItem.DataRefund.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                          0)
                      )
                      : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                          0)
                      )
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { cash_card_amount }
                        ) {
                          return accumulator + parseFloat(cash_card_amount);
                        },
                          0) -
                        dailyReportItem.DataRefund.reduce(function (
                          accumulator,
                          { cash_card_refund }
                        ) {
                          return accumulator + parseFloat(cash_card_refund);
                        },
                          0)
                      )
                      : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { cash_card_amount }
                        ) {
                          return accumulator + parseFloat(cash_card_amount);
                        },
                          0)
                      )
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_amount }
                        ) {
                          return accumulator + parseFloat(gross_amount);
                        },
                          0) -
                        dailyReportItem.DataRefund.reduce(function (
                          accumulator,
                          { gross_amount }
                        ) {
                          return accumulator + parseFloat(gross_amount);
                        },
                          0)
                      )
                      : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_amount }
                        ) {
                          return accumulator + parseFloat(gross_amount);
                        },
                          0)
                      )
                  )
                }}</strong>
              </td>
              <!-- <td class="text-right">
                <strong>{{
                  dailyReportItem.DataRefund
                    ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { net_revenue }
                        ) {
                          return accumulator + parseFloat(net_revenue);
                        },
                        0) -
                          dailyReportItem.DataRefund.reduce(function (
                            accumulator,
                            { net_revenue }
                          ) {
                            return accumulator + parseFloat(net_revenue);
                          },
                          0)
                      )
                    : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { net_revenue }
                        ) {
                          return accumulator + parseFloat(net_revenue);
                        },
                        0)
                      )
                }}</strong>
              </td> -->
              <td class="text-right">
                <strong>{{
                  currFormat(
                    dailyReportItem.DataRefund
                      ? currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                          0) -
                        dailyReportItem.DataRefund.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                          0)
                      )
                      : currFormat(
                        dailyReportItem.Data.reduce(function (
                          accumulator,
                          { gross_revenue }
                        ) {
                          return accumulator + parseFloat(gross_revenue);
                        },
                          0)
                      )
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-for="(DailyConcessionReportItem,
            DailyConcessionReportItemIndex) in getDailyConcessionReportList" :key="DailyConcessionReportItemIndex">
            <tr>
              <td rowspan="9">
                <strong>{{ $t("concession") }}</strong>
              </td>
            </tr>
            <tr>
              <td rowspan="9">
                <strong>{{ DailyConcessionReportItem.first_name }}&nbsp;{{
                  DailyConcessionReportItem.last_name
                }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>

            <tr v-for="(TransactionItem,
              TransactionIndex) in DailyConcessionReportItem.transactions" :key="TransactionIndex">
              <td></td>
              <td class="text-left">{{ TransactionItem.pm_payment_mode }}</td>
              <td></td>
              <td>{{ TransactionItem.number_of_tickets }}</td>
              <td class="text-right">
                {{ currFormat(TransactionItem.net_revenue) }}
              </td>
              <td class="text-right">0.00</td>
              <td class="text-right">
                {{ currFormat(TransactionItem.gross_revenue) }}
              </td>
            </tr>

            <tr>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong>{{
                  DailyConcessionReportItem.transactions.reduce(function (
                    accumulator,
                    { number_of_tickets }
                  ) {
                    return accumulator + parseFloat(number_of_tickets);
                  },
                    0)
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    DailyConcessionReportItem.transactions.reduce(function (
                      accumulator,
                      { net_revenue }
                    ) {
                      return accumulator + parseFloat(net_revenue);
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td class="text-right">0.00</td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    DailyConcessionReportItem.transactions.reduce(function (
                      accumulator,
                      { gross_revenue }
                    ) {
                      return accumulator + parseFloat(gross_revenue);
                    },
                      0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-if="getDailyConcessionReportList.length > 0">
            <tr>
              <td colspan="5">
                <strong>{{ $t("concession") }}</strong>
              </td>
              <td>
                <strong>{{
                  getConcessionOfficeTotal.totalNumberOfTickets
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(getConcessionOfficeTotal.totalNetRevenue)
                }}</strong>
              </td>
              <td class="text-right">0.00</td>
              <td class="text-right">
                <strong>{{
                  currFormat(getConcessionOfficeTotal.totalGrossRevenue)
                }}</strong>
              </td>
            </tr>
          </tbody>

          <tbody v-if="
            getDailyConcessionReportList.length > 0 ||
            getDailyReportList.length > 0
          ">
            <tr>
              <td colspan="2" class="bg-lightgrey text-left">
                <strong>{{ $t("grand") }} {{ $t("total") }}</strong>
              </td>
              <!-- <td class="bg-lightgrey">
                <strong></strong>
              </td> -->
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey">
                <strong></strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong>{{ getGrandTotal.totalNumberOfTickets }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong>{{ currFormat(getGrandTotal.totalCashAmount) }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong>{{
                  currFormat(getGrandTotal.totalPaymentmodeAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong v-if="getGrandTotal.totalDiscount">{{
                  currFormat(getGrandTotal.totalDiscount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong>{{
                  currFormat(getGrandTotal.totalCashCardAmount)
                }}</strong>
              </td>
              <td class="bg-lightgrey text-right">
                <strong>{{
                  currFormat(getGrandTotal.totalGrossAmount)
                }}</strong>
              </td>
              <!-- <td class="bg-lightgrey text-right">
                <strong v-if="getGrandTotal.totalNetRevenue">{{
                  currFormat(getGrandTotal.totalNetRevenue)
                }}</strong>
              </td> -->
              <td class="bg-lightgrey text-right">
                <strong>{{
                  currFormat(getGrandTotal.totalGrossRevenue)
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- New table design -->
      <div v-if="false" class="row mx-0 mt-3 reports-box">
        <div class="col-2">
          <p class="light-title">Outlet</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Username</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Item</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Payment Type</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Offer</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Quantity</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-12">
          <hr class="my-2" />
        </div>
        <div class="col-2">
          <p class="light-title">Gross Revenue</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Net Revenue</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Discount</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-2">
          <p class="light-title">Balance</p>
          <p class="total-dark">0</p>
        </div>
        <div class="col-12">
          <hr class="my-2" />
        </div>
      </div>

      <div v-if="getCashRefundVoucher.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="8">Refund of Cash against voucher</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th class="text-left">Outlet</th>
              <th class="text-left">Name Of Voucher</th>
              <th class="text-left">Type Of voucher</th>
              <th class="text-right">Gross Value of Voucher</th>
              <th class="text-right">Consumed Valued</th>
              <th class="text-right">Refund Value</th>
              <th class="text-left">Payment Type</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(UserItem, UserIndex) in getCashRefundVoucher" :key="UserIndex">
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td class="text-left">{{ UserItem.outlet }}</td>
              <td class="text-left">{{ UserItem.voucher_name }}</td>
              <td class="text-left">{{ UserItem.voucher_type }}</td>
              <td class="text-right">
                {{ currFormat(UserItem.totalVoucherAmount) }}
              </td>
              <td class="text-right">
                {{ currFormat(UserItem.t_gross_amount_before_offer) }}
              </td>
              <td class="text-right">
                {{ currFormat(UserItem.cash_refund_amount) }}
              </td>
              <td class="text-left">{{ UserItem.pm_payment_mode }}</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="4" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { totalVoucherAmount }
                    ) {
                      return accumulator + parseFloat(totalVoucherAmount);
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { t_gross_amount_before_offer }
                    ) {
                      return (
                        accumulator + parseFloat(t_gross_amount_before_offer)
                      );
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getCashRefundVoucher.reduce(function (
                      accumulator,
                      { cash_refund_amount }
                    ) {
                      return accumulator + parseFloat(cash_refund_amount);
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getSaleCashCard.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="7">Sale of Cash Card</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th class="text-left">Issuer</th>
              <th class="text-right">No of Cash Card</th>
              <th class="text-right">Value Per Cash Card</th>
              <th class="text-right">Processing Fee</th>
              <th class="text-right">Total</th>
              <th class="text-left">Payment Type</th>
              <th class="">View Cash Card List</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(UserItem, UserIndex) in getSaleCashCard" :key="UserIndex">
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td class="text-left">{{ UserItem.cash_Card_issuer }}</td>
              <td class="text-right">{{ UserItem.no_of_cash_card }}</td>
              <td class="text-right">
                {{ currFormat(UserItem.payment_value) }}
              </td>
              <td class="text-right">
                {{ currFormat(UserItem.processing_fee) }}
              </td>
              <td class="text-right">{{ currFormat(UserItem.total) }}</td>
              <td class="text-left">{{ UserItem.payment_mode_name }}</td>
              <td>
                <span class="icon-eye mr-1" @click="showCardList(UserItem)"></span>
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  getSaleCashCard.reduce(function (
                    accumulator,
                    { no_of_cash_card }
                  ) {
                    return accumulator + parseFloat(no_of_cash_card);
                  },
                    0)
                }}</strong>
              </td>
              <td></td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function (
                      accumulator,
                      { processing_fee }
                    ) {
                      return accumulator + parseFloat(processing_fee);
                    },
                      0)
                  )
                }}</strong>
              </td>

              <td class="text-right">
                <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function (accumulator, { total }) {
                      return accumulator + parseFloat(total);
                    }, 0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <!-- <strong>{{
                  currFormat(
                    getSaleCashCard.reduce(function(
                      accumulator,
                      { cash_refund_amount }
                    ) {
                      return (
                        accumulator +
                        (parseFloat(cash_refund_amount))
                      );
                    },
                    0)
                  )
                }}</strong> -->
              </td>
              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getTopUpCashCard.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="3">Topup Cash Card</th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">SR. No</th>
              <th class="text-left">Payment Mode</th>
              <th class="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(UserItem, UserIndex) in getTopUpCashCard" :key="UserIndex">
              <td class="text-left">{{ UserIndex + 1 }}</td>
              <td class="text-left">{{ UserItem.pm_payment_mode }}</td>

              <td class="text-right">{{ currFormat(UserItem.amount) }}</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getTopUpCashCard.reduce(function (accumulator, { amount }) {
                      return accumulator + parseFloat(amount);
                    }, 0)
                  )
                }}</strong>
              </td>

              <!-- <td></td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getPaymentSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">
                {{ $tc("payment", 1) }} {{ $t("type") }} {{ $t("wise") }}
                {{ $t("summary") }} - {{ "Tickets/f&b Sales" }}
              </th>
            </tr>
            <tr class="bg-lightgrey text-left">
              <th class="text-left" rowspan="2">
                {{ "Channel" }}
              </th>
              <th class="text-left" rowspan="2">
                {{ "PayType" }}
              </th>
              <th class="text-center">{{ $t("current") }} sold</th>
              <th class="text-center">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}
              </th>
              <th rowspan="2" class="text-right">Total</th>
            </tr>
            <tr class="bg-lightgrey">
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <!-- <th class="text-right">{{ $tc("ticket", 1) }}</th> -->
                      <th class="text-right">
                        {{ "Sale" }}
                      </th>
                      <th class="text-right">
                        {{ "Refund" }}
                      </th>
                      <th class="text-right">
                        <span class="fs-12">{{ "Balance" }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <!-- <th class="text-right">{{ $tc("ticket", 1) }}</th> -->
                      <th class="text-right">
                        {{ "Sale" }}
                      </th>
                      <th class="text-right">
                        {{ "Refund" }}
                      </th>
                      <!-- <th class="text-right">
                        {{ $t("total") }} {{ $t("net") }}
                      </th> -->
                      <th class="text-right">
                        <span class="fs-12">{{ "Balance" }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(Payment, PaymentIndex) in getPaymentSummary" :key="PaymentIndex">
              <td class="text-left">{{ Payment.bs_source }}</td>
              <td class="text-left">{{ Payment.pm_payment_mode }}</td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <!-- <td class="text-right">{{ Payment.tickets }}</td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.payment_mode_amount) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(getNegativeValue(Payment.refundAmount)) }}
                    </td>
                    <!-- <td class="text-right">
                      {{ currFormat(Payment.net_amount) }}
                    </td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.balance) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <!-- <td class="text-right">{{ Payment.advanceTickets }}</td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.advance_payment_mode_amount) }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          getNegativeValue(Payment.advanceRefundAmount)
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{ currFormat(Payment.advanceNetAmount) }}
                    </td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.advanceBalance) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{ currFormat(Payment.balance + Payment.advanceBalance) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <!-- <td class="text-right">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                        0)
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { payment_mode_amount }
                          ) {
                            return (
                              accumulator + parseFloat(payment_mode_amount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <td class="text-right fahad">
                      <!-- {{
                        currFormat(

                            getPaymentSummary.reduce(function(
                              accumulator,
                              { refundAmount }
                            ) {
                              return accumulator + parseFloat(refundAmount);
                            },
                            0)

                        )
                      }} -->
                      -{{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { refundAmount }
                          ) {
                            return accumulator + refundAmount;
                          },
                            0)
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { balance }
                          ) {
                            return accumulator + parseFloat(balance);
                          },
                            0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <!-- <td class="text-right">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                        0)
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advance_payment_mode_amount }
                          ) {
                            return (
                              accumulator +
                              parseFloat(advance_payment_mode_amount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      -{{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceRefundAmount }
                          ) {
                            return (
                              accumulator + parseFloat(advanceRefundAmount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceBalance }
                          ) {
                            return accumulator + parseFloat(advanceBalance);
                          },
                            0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getPaymentSummary.reduce(function (
                      accumulator,
                      { advanceBalance, balance }
                    ) {
                      return (
                        accumulator +
                        parseFloat(balance) +
                        parseFloat(advanceBalance)
                      );
                    },
                      0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getPaymentSummary.length > 0 && false" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">
                {{ $tc("payment", 1) }} {{ $t("type") }} {{ $t("wise") }}
                {{ $t("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey text-left">
              <th class="text-left" rowspan="2">
                {{ "Channel" }}
              </th>
              <th class="text-left" rowspan="2">
                {{ "PayType" }}
              </th>
              <th>{{ $t("current") }} sold</th>
              <th>{{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}</th>
              <th rowspan="2" class="text-right">Total</th>
            </tr>
            <tr class="bg-lightgrey">
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-right">{{ $tc("ticket", 1) }}</th>
                      <th class="text-right">
                        {{ $tc("Payment Mode Amount", 1) }}
                      </th>
                      <th class="text-right">
                        {{ $tc("Cash Card Amount", 1) }}
                      </th>
                      <!-- <th class="text-right">
                        {{ $t("total") }} {{ $t("net") }}
                      </th> -->
                      <th class="text-right">
                        <span class="fs-12">{{ "Total Sales" }}</span> <br />
                        <span class="fs-10 text-truncate">{{
                          "(Less discount)"
                        }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-right">{{ $tc("ticket", 1) }}</th>
                      <th class="text-right">
                        {{ $tc("Payment Mode Amount", 1) }}
                      </th>
                      <th class="text-right">
                        {{ $tc("Cash Card Amount", 1) }}
                      </th>
                      <!-- <th class="text-right">
                        {{ $t("total") }} {{ $t("net") }}
                      </th> -->
                      <th class="text-right">
                        <span class="fs-12">{{ "Total Sales" }}</span> <br />
                        <span class="fs-10 text-truncate">{{
                          "(Less discount)"
                        }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(Payment, PaymentIndex) in getPaymentSummary" :key="PaymentIndex">
              <td class="text-left">{{ Payment.bs_source }}</td>
              <td class="text-left">{{ Payment.pm_payment_mode }}</td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">{{ Payment.tickets }}</td>
                    <td class="text-right">
                      {{ currFormat(Payment.payment_mode_amount) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(Payment.cash_card_amount) }}
                    </td>
                    <!-- <td class="text-right">
                      {{ currFormat(Payment.net_amount) }}
                    </td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.gross_amount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">{{ Payment.advanceTickets }}</td>
                    <td class="text-right">
                      {{ currFormat(Payment.advance_payment_mode_amount) }}
                    </td>
                    <td class="text-right">
                      {{ currFormat(Payment.advance_cash_card_amount) }}
                    </td>
                    <!-- <td class="text-right">
                      {{ currFormat(Payment.advanceNetAmount) }}
                    </td> -->
                    <td class="text-right">
                      {{ currFormat(Payment.advanceGrossAmount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{
                  currFormat(Payment.gross_amount + Payment.advanceGrossAmount)
                }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { tickets }
                        ) {
                          return accumulator + parseFloat(tickets);
                        },
                          0)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { payment_mode_amount }
                          ) {
                            return (
                              accumulator + parseFloat(payment_mode_amount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { cash_card_amount }
                          ) {
                            return accumulator + parseFloat(cash_card_amount);
                          },
                            0)
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                            0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">
                      {{
                        getPaymentSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                          0)
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advance_payment_mode_amount }
                          ) {
                            return (
                              accumulator +
                              parseFloat(advance_payment_mode_amount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advance_cash_card_amount }
                          ) {
                            return (
                              accumulator + parseFloat(advance_cash_card_amount)
                            );
                          },
                            0)
                        )
                      }}
                    </td>
                    <!-- <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}
                    </td> -->
                    <td class="text-right">
                      {{
                        currFormat(
                          getPaymentSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                            0)
                        )
                      }}
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    getPaymentSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(gross_amount) +
                        parseFloat(advanceGrossAmount)
                      );
                    },
                      0)
                  )
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getFilmSummary.length > 0" class="swc-report mt-3">
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">Film Wise Summary</th>
            </tr>
            <tr class="bg-lightgrey">
              <th rowspan="2" class="text-left">Movie</th>
              <th class="text-left">{{ $t("current") }}</th>
              <th class="text-left">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}
              </th>
              <th rowspan="2" class="text-right">Total</th>
            </tr>
            <tr class="bg-lightgrey">
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-right">{{ $tc("ticket", 1) }}</th>
                      <!-- <th class="text-right">
                        {{ $t("total") }} {{ $t("net") }}
                      </th> -->
                      <th class="text-right">
                        <span class="fs-12">{{ "Total Sales" }}</span> <br />
                        <span class="fs-10 text-truncate">{{
                          "(Less discount)"
                        }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
              <th>
                <table class="fixed-layout-table">
                  <thead>
                    <tr>
                      <th class="text-right">{{ $tc("ticket", 1) }}</th>
                      <!-- <th class="text-right">
                        {{ $t("total") }} {{ $t("net") }}
                      </th> -->
                      <th class="text-right">
                        <span class="fs-12">{{ "Total Sales" }}</span> <br />
                        <span class="fs-10 text-truncate">{{
                          "(Less discount)"
                        }}</span>
                      </th>
                    </tr>
                  </thead>
                </table>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(filmItem, filmIndex) in getFilmSummary" :key="filmIndex">
              <td class="text-left">
                <strong>{{ filmItem.movie }}</strong>
              </td>
              <td class="p-0">
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center">{{ filmItem.ticket }}</td>
                    <!-- <td class="text-right">
                      {{ currFormat(filmItem.net_amount) }}
                    </td> -->
                    <td class="text-right p-0">
                      {{ currFormat(filmItem.gross_amount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">{{ filmItem.advanceTickets }}</td>
                    <!-- <td class="text-right">
                      {{ currFormat(filmItem.advanceNetAmount) }}
                    </td> -->
                    <td class="text-right">
                      {{ currFormat(filmItem.advanceGrossAmount) }}
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                {{
                  currFormat(
                    filmItem.gross_amount + filmItem.advanceGrossAmount
                  )
                }}
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td class="p-0">
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-center pr-0">
                      <strong>{{
                        getFilmSummary.reduce(function (
                          accumulator,
                          { ticket }
                        ) {
                          return accumulator + parseFloat(ticket);
                        },
                          0)
                      }}</strong>
                    </td>
                    <!-- <td class="text-right">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { net_amount }
                          ) {
                            return accumulator + parseFloat(net_amount);
                          },
                          0)
                        )
                      }}</strong>
                    </td> -->
                    <td class="text-right p-0">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { gross_amount }
                          ) {
                            return accumulator + parseFloat(gross_amount);
                          },
                            0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <table class="fixed-layout-table">
                  <tr>
                    <td class="text-right">
                      <strong>{{
                        getFilmSummary.reduce(function (
                          accumulator,
                          { advanceTickets }
                        ) {
                          return accumulator + parseFloat(advanceTickets);
                        },
                          0)
                      }}</strong>
                    </td>
                    <!-- <td class="text-right">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { advanceNetAmount }
                          ) {
                            return accumulator + parseFloat(advanceNetAmount);
                          },
                          0)
                        )
                      }}</strong>
                    </td> -->
                    <td class="text-right">
                      <strong>{{
                        currFormat(
                          getFilmSummary.reduce(function (
                            accumulator,
                            { advanceGrossAmount }
                          ) {
                            return accumulator + parseFloat(advanceGrossAmount);
                          },
                            0)
                        )
                      }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getFilmSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount, gross_amount }
                    ) {
                      return (
                        accumulator +
                        parseFloat(advanceGrossAmount) +
                        parseFloat(gross_amount)
                      );
                    },
                      0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getUserWiseSummary.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="6">
                {{ $tc("user") }} {{ $tc("wise") }} {{ $tc("summary") }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ "Channel" }}</th>
              <th class="text-left">{{ $tc("user", 1) }}</th>
              <th class="text-right">{{ $t("current") }}</th>
              <th class="text-right">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}
              </th>
              <th class="text-right">{{ $t("total") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(UserItem, UserIndex) in getUserWiseSummary" :key="UserIndex">
              <td class="text-left">{{ UserItem.bs_source }}</td>
              <td class="text-left">{{ UserItem.booking_user_name }}</td>
              <td class="text-right">
                {{ currFormat(UserItem.gross_amount) }}
              </td>
              <td class="text-right">
                {{ currFormat(UserItem.advanceGrossAmount) }}
              </td>
              <td class="text-right">
                {{
                  currFormat(
                    UserItem.advanceGrossAmount + UserItem.gross_amount
                  )
                }}
              </td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount }
                    ) {
                      return accumulator + parseFloat(gross_amount);
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { advanceGrossAmount }
                    ) {
                      return accumulator + parseFloat(advanceGrossAmount);
                    },
                      0)
                  )
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getUserWiseSummary.reduce(function (
                      accumulator,
                      { gross_amount, advanceGrossAmount }
                    ) {
                      return (
                        accumulator +
                        (parseFloat(advanceGrossAmount) +
                          parseFloat(gross_amount))
                      );
                    },
                      0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="getRefundSummary.length > 0" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="5">
                {{ $tc("refund", 1) }} {{ $t("summary") }} - {{ "Tickets" }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ "Channel" }}</th>
              <th class="text-left">{{ $tc("user", 1) }}</th>
              <th class="text-left">{{ "PayType" }}</th>
              <th class="text-right">{{ $tc("ticket", 1) }}</th>
              <th class="text-right">
                {{ $tc("refund", 1) }} {{ $t("value") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(RefundItem, RefundIndex) in getRefundSummary" :key="RefundIndex">
              <td class="text-left">{{ RefundItem.bs_source }}</td>
              <td class="text-left">{{ RefundItem.username }}</td>
              <td class="text-left">{{ RefundItem.pm_payment_mode }}</td>
              <td class="text-right">{{ RefundItem.tickets }}</td>
              <td class="text-right">{{ currFormat(RefundItem.refund) }}</td>
            </tr>

            <tr class="bg-lightgrey">
              <td class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td>
                <strong></strong>
              </td>
              <td class="text-right">
                <strong>{{
                  getRefundSummary.reduce(function (accumulator, { tickets }) {
                    return accumulator + parseFloat(tickets);
                  }, 0)
                }}</strong>
              </td>
              <td class="text-right">
                <strong>{{
                  currFormat(
                    getRefundSummary.reduce(function (accumulator, { refund }) {
                      return accumulator + parseFloat(refund);
                    }, 0)
                  )
                }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="false" class="swc-report mt-3">
        <table border="1" class="swc-report-table" style="table-layout: auto">
          <thead>
            <tr>
              <th colspan="4">
                {{ $t("advance") }} {{ $t("sold") }} {{ $t("today") }}'s
                (20-Sep-2019) {{ $t("show") }}
              </th>
            </tr>
            <tr class="bg-lightgrey">
              <th class="text-left">{{ $t("outlet") }}</th>
              <th>{{ $tc("payment", 1) }} {{ $tc("type", 1) }}</th>
              <th>{{ $tc("ticket", 1) }}</th>
              <th class="text-right">{{ $t("rrevenue") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-left">{{ $t("boxoffice") }}</td>
              <td>{{ $t("cash") }}</td>
              <td>6</td>
              <td class="text-right">189.00</td>
            </tr>

            <tr class="bg-lightgrey">
              <td colspan="2" class="text-left">
                <strong>{{ $t("total") }}</strong>
              </td>
              <td>
                <strong>21</strong>
              </td>
              <td class="text-right">
                <strong>787.77</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- DAILY CONCESSION REPORT -->

    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <h5>{{ $t("dailySalesConcessionReport") }}</h5>
        <div v-if="
          // getDailyReportList.length > 0 ||
          // getDailyConcessionReportList.length > 0 ||
          getDailyconcessionDataArray.length > 0
        " class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center">
          <div v-if="
            // getDailyReportList.length > 0 ||
            // getDailyConcessionReportList.length > 0 ||
            getDailyconcessionDataArray.length > 0
          ">{{ $t("download") }} as:</div>
          <!-- :href="BASE_URL + getConcessionDailyPdfFileName" -->
          <a @click="getDailyconcessionData('Y')" target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a v-if="getConcessionDailyExcelFileName" :href="BASE_URL + getConcessionDailyExcelFileName" target="_blank"
            title="Download as Excel" download>
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <!-- New Design Start-->

      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table dailysales_report" style="table-layout:  'auto'">
          <thead class="bg-lightgrey">
            <tr>
              <th class="text-center">{{ "Channel" }}</th>

              <th class="text-center">User</th>
              <th class="text-center">PayType</th>
              <th class="text-center">Voucher</th>
              <th class="text-center">Qty</th>
              <th class="text-center">Revenue</th>
              <!-- <th class="text-center">CreditCard</th> -->
              <th class="text-center">Discount</th>
              <!-- <th class="text-center">CashCard</th> -->
              <!-- <th>Quantity</th> -->
              <th class="text-center">Balance</th>

              <!-- <th class="text-right">
                <span class="fs-12">{{ "Total Sales" }}</span> <br />
                <span class="fs-10 text-truncate">{{ "(Less discount)" }}</span>
              </th> -->
            </tr>
          </thead>

          <tbody v-if="getDailyconcessionDataArray.length">
            <template v-for="(ConcessionItem,
              ConcessionIndex) in getDailyconcessionDataArray">
              <tr :key="ConcessionIndex + 'ConcessionIndex'">
                <td :rowspan="ConcessionItem.rowspan1 +
                  ConcessionItem.bookingArr.length +
                  1
                  " style="white-space:nowrap">{{ ConcessionItem.bookingSource }}</td>
              </tr>
              <template v-for="(userdata, userIndex) in ConcessionItem.bookingArr">
                <tr :key="userIndex + 'userIndex'">
                  <td :rowspan="userdata.usersData.length + 1" class="text-left">{{ userdata.user_name }}</td>
                </tr>

                <template v-for="(userdatamain,
                  userdatamainIndex) in userdata.usersData">
                  <tr :key="userdatamainIndex + 'userdatamainIndex'">
                    <td class="text-left">
                      {{ userdatamain.pm_payment_mode }}
                    </td>
                    <td class="text-left">
                      {{ userdatamain.ft_offer_name }}
                    </td>
                    <td class="text-right">
                      {{ userdatamain.qty }}
                    </td>
                    <td class="text-right">
                      {{ +parseFloat(userdatamain.total_amount).toFixed(MIN_FRACTION_DIGITS) }}
                    </td>
                    <td class="text-right">
                      {{ +parseFloat(userdatamain.offer_price).toFixed(MIN_FRACTION_DIGITS) }}
                    </td>
                    <td class="text-right">
                      {{
                        +parseFloat(
                          userdatamain.total_amount - userdatamain.offer_price
                        ).toFixed(MIN_FRACTION_DIGITS)
                      }}
                    </td>
                  </tr>
                </template>
                <tr style="background-color: rgba(169, 217, 251, 0.5);">
                  <td colspan="3" class="text-left font-weight-bold">Total</td>

                  <!--Qty Total-->
                  <td class="text-right font-weight-bold">{{
                    userdata.usersData.reduce(function (accumulator, { qty }) {
                      return accumulator + parseFloat(qty);
                    }, 0)
                  }}</td>

                  <!--Revenue Total-->
                  <td class="text-right font-weight-bold">{{
                    userdata.usersData
                      .reduce(function (accumulator, { total_amount }) {
                        return accumulator + parseFloat(total_amount);
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}</td>

                  <!--Discount Total-->
                  <td class="text-right font-weight-bold">{{
                    userdata.usersData
                      .reduce(function (accumulator, { offer_price }) {
                        return accumulator + parseFloat(offer_price);
                      }, 0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}</td>

                  <!--Balance Total-->
                  <td class="text-right font-weight-bold">{{
                    userdata.usersData
                      .reduce(function (
                        accumulator,
                        { total_amount, offer_price }
                      ) {
                        return (
                          accumulator +
                          parseFloat(total_amount) -
                          parseFloat(offer_price)
                        );
                      },
                        0)
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}</td>
                </tr>
              </template>

              <!-- Idividual Total-->
            </template>

            <!--Grand Total-->
            <tr class="bg-lightgrey" v-if="getDailyconcessionDataArray.length > 0">
              <td colspan="4" class="font-weight-bold text-left">Grand Total
              </td>
              <td class="font-weight-bold text-right">{{
                +parseFloat(getDailyConcessionGrandTotal.total_qty).toFixed(MIN_FRACTION_DIGITS)
              }}
              </td>
              <td class="font-weight-bold text-right">{{
                +parseFloat(
                  getDailyConcessionGrandTotal.total_revenue
                ).toFixed(MIN_FRACTION_DIGITS)
              }}
              </td>
              <td class="font-weight-bold text-right">{{
                +parseFloat(
                  getDailyConcessionGrandTotal.total_discount
                ).toFixed(MIN_FRACTION_DIGITS)
              }}
              </td>
              <td class="font-weight-bold text-right">{{
                +parseFloat(
                  getDailyConcessionGrandTotal.total_balance
                ).toFixed(MIN_FRACTION_DIGITS)
              }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--Todays Advance Report Start-->
    <div class="white-wrapper" v-if="
      getDailyReportFromDate &&
      moment(getDailyReportFromDate).format() ==
      moment(getDailyReportToDate).format()
    ">
      <div class="d-flex justify-content-between">
        <h5>{{
          `Advance Sold for Today's (${moment(getDailyReportFromDate).format(
            "DD MMM YYYY"
          )}) Shows`
        }}</h5>
        <div v-if="getTodaysAdvanceSalesRecords.length > 0"
          class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center">
        </div>
      </div>

      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table dailysales_report" style="table-layout: 'auto'">
          <thead class="bg-lightgrey text-center">
            <tr>
              <th class="text-left">Outlet</th>
              <th class="text-left">Payment Type</th>
              <th class="text-left">Ticket</th>
              <th>Revenue</th>
            </tr>
          </thead>

          <tbody v-if="
            getTodaysAdvanceSalesRecords &&
            getTodaysAdvanceSalesRecords.length > 0
          ">
            <tr v-for="(advanceSalesToday,
              advanceSalesTodayIndex) in getTodaysAdvanceSalesRecords" :key="advanceSalesTodayIndex + 'addonsIndex'">
              <td class="text-left">
                {{ advanceSalesToday.bs_source }}
              </td>
              <td class="text-left">
                {{ advanceSalesToday.pm_payment_mode }}
              </td>
              <td class="text-right">
                {{ advanceSalesToday.totalTickets || "-" }}
              </td>
              <td class="text-right">
                {{ currFormat(advanceSalesToday.total_amount || 0) || "-" }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2">Total</td>
              <td class="text-right">{{
                getTodaysAdvanceSalesRecords.reduce((acc, { totalTickets }) => {
                  return acc + totalTickets ? parseFloat(totalTickets) : 0;
                }, 0)
              }}</td>
              <td class="text-right">{{
                getTodaysAdvanceSalesRecords.reduce((acc, { total_amount }) => {
                  return acc + total_amount ? parseFloat(total_amount) : 0;
                }, 0)
              }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr rowspan="12">
              <td colspan="12">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Advanced Sales Report -->

    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <h5>{{ $t("Advance Daily Sales Summary") }}</h5>
        <div v-if="
          // getDailyReportList.length > 0 ||
          // getDailyConcessionReportList.length > 0 ||
          getDailyconcessionDataArray.length > 0
        " class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center">
          <div v-if="
            // getDailyReportList.length > 0 ||
            // getDailyConcessionReportList.length > 0 ||
            getDailyconcessionDataArray.length > 0
          ">{{ $t("download") }} as:</div>
          <!-- :href="BASE_URL + getConcessionDailyPdfFileName" -->
          <a @click="getDailyconcessionData('Y')" target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a v-if="getConcessionDailyExcelFileName" :href="BASE_URL + getConcessionDailyExcelFileName" target="_blank"
            title="Download as Excel" download>
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <!-- New Design Start-->

      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table dailysales_report" style="table-layout:  'auto'">
          <tbody v-if="getAdvanceSalesRecords.length > 0">
            <!-- <thead class="bg-lightgrey"> -->
            <tr class="bg-lightgrey">
              <td class="font-weight-bold" :colspan="Object.values(getAdvanceSalesHeaders).length * 2 + 2">Advance Sold
                Summary</td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="font-weight-bold" rowspan="2">Show Date & Time</td>
              <template v-for="(paymentData, paymentIndex) in Object.values(
                getAdvanceSalesHeaders
              )">
                <td class="font-weight-bold" colspan="2">{{ paymentData }}</td>
              </template>
              <td class="font-weight-bold" rowspan="2">Refund</td>
            </tr>
            <tr class="bg-lightgrey">
              <template v-for="(paymentData, paymentIndex123) in Object.values(
                getAdvanceSalesHeaders
              )">
                <td :key="paymentIndex123" class="font-weight-bold">BO</td>
                <td :key="paymentIndex123" class="font-weight-bold">F&B</td>
              </template>
            </tr>
            <!-- </thead> -->
            <tr v-for="(salesData, salesDataIndex) in getAdvanceSalesRecords">
              <td class="text-left">{{ salesData.date }} {{ salesData.time }}</td>
              <template v-for="(paymentData, paymentIndex345) in Object.keys(
                getAdvanceSalesHeaders
              )">
                <td class="text-right">{{
                  salesData[`${paymentData}_bo`]
                    ? currFormat(salesData[`${paymentData}_bo`])
                    : 0
                }}</td>
                <td class="text-right">{{
                  salesData[`${paymentData}_fnb`]
                    ? currFormat(salesData[`${paymentData}_fnb`])
                    : 0
                }}</td>
              </template>
              <td class="text-right">{{ currFormat(salesData.refunded) }}</td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="bg-lightgrey text-left">Grand Total</td>
              <template v-for="(paymentHeader, paymentHeaderIndex) in Object.keys(
                getAdvanceSalesHeaders
              )">
                <td :key="paymentHeaderIndex" class="text-right">{{
                  currFormat(grandTotalAdvanceSales[`${paymentHeader}_bo`])
                }}</td>
                <td :key="paymentHeaderIndex" class="text-right">{{
                  currFormat(grandTotalAdvanceSales[`${paymentHeader}_fnb`])
                }}</td>
              </template>
              <td class="bg-lightgrey text-right">{{
                currFormat(grandTotalAdvanceSales["refunded_grand_total"])
              }}</td>
            </tr>
          </tbody>

          <tbody v-else>
            <!-- <thead class="bg-lightgrey"> -->
            <tr class="bg-lightgrey">
              <td colspan="10">Advance Sold Summary</td>
            </tr>
            <tr class="bg-lightgrey">
              <td rowspan="2">Date</td>
              <td colspan="2">Cash</td>
              <td colspan="2">Credit Card</td>
              <td colspan="2">Complementary</td>
              <td colspan="2">Prepaid</td>
              <td rowspan="2">Refund</td>
            </tr>
            <tr class="bg-lightgrey">
              <td>Bo</td>
              <td>F&B</td>
              <td>Bo</td>
              <td>F&B</td>
              <td>Bo</td>
              <td>F&B</td>
              <td>Bo</td>
              <td>F&B</td>
            </tr>
            <!-- </thead> -->
            <tr>
              <td colspan="10">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--Addons Report Start-->
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <h5>{{ $t("Addons Amount Summary") }}</h5>
        <div v-if="
          // getDailyReportList.length > 0 ||
          // getDailyConcessionReportList.length > 0 ||
          getConcessionDailyReportData.length > 0
        " class="col-lg-6 col-xl-6 align-self-center mb-3 d-flex justify-content-end align-items-center">
          <div v-if="
            // getDailyReportList.length > 0 ||

            // getDailyConcessionReportList.length > 0 ||
            getConcessionDailyReportData.length > 0
          ">{{ $t("download") }} as:</div>
          <a v-if="getConcessionDailyPdfFileName" :href="BASE_URL + getConcessionDailyPdfFileName" target="_blank"
            download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>
          <a v-if="getConcessionDailyExcelFileName" :href="BASE_URL + getConcessionDailyExcelFileName" target="_blank"
            title="Download as Excel" download>
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>

      <div class="swc-report">
        <table border="1" class="swc-report swc-report-table dailysales_report" style="table-layout: 'auto'">
          <thead class="bg-lightgrey text-center">
            <tr>
              <th class="text-left">Film</th>
              <th class="text-left">Addons</th>
              <th class="text-left">No. of Tickets</th>
              <th>Total Amount</th>
            </tr>
          </thead>

          <tbody v-if="addonsArray && addonsArray.length > 0">
            <tr v-for="(addonsData, addonsIndex) in addonsArray" :key="addonsIndex + 'addonsIndex'">
              <td class="text-left">
                {{ addonsData.movie_name }}
              </td>
              <td class="text-left">
                {{ addonsData.addon_name }}
              </td>
              <td class="text-right">
                {{ addonsData.total_quantity || "-" }}
              </td>
              <td class="text-right">
                {{ addonsData.total_price || "-" }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td colspan="2">Total</td>
              <td class="text-right">{{
                addonsArray.reduce((acc, { total_quantity }) => {
                  return acc + total_quantity ? parseFloat(total_quantity) : 0;
                }, 0)
              }}</td>
              <td class="text-right">{{
                addonsArray.reduce((acc, { total_price }) => {
                  return acc + total_price ? parseFloat(total_price) : 0;
                }, 0)
              }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!--Addons Report End-->

    <b-modal id="cardDetails" title="Cash Cards" hide-footer hide-header>
      <div class="">
        <table class="list-view-table border m-0" v-if="showCardListNew.length > 0">
          <thead>
            <tr>
              <th>{{ $tc("card") }} {{ $tc("number") }}</th>
              <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
              <th class="text-right">
                <span class="">{{ $tc("status", 2) }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(card, key) in showCardListNew" :key="key">
              <td>{{ card.cash_card_number || "-" }}</td>
              <td>
                {{ card.customer_name ? card.customer_name : "Street Sale" }}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-end mr-4">
                  <StatusDot :status="card.cash_card_is_active === 'Y'
                      ? 'active'
                      : card.cash_card_is_active === 'N' && 'inactive'
                    " />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
import ReportsServiceV2 from "@/services/ReportsService-v2";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
import moment from "moment";

export default {
  components: {
    NoRecords,
    StatusDot,
  },
  data() {
    return {
      refundedarr: [],
      BASEURL,
      DailyReportDataV2: [],
      getDailyconcessionDataArray: [],
      addonsArray: [],
      addonsArrayTotal: 0,
      addonsArrayTotalArray: 0,
      getDailyConcessionGrandTotal: {},
      getTodaysAdvanceSalesRecords: [],
      getAdvanceSalesRecords: [],
      getAdvanceSalesHeaders: {},
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      showCardListNew: [],
      grandTotalAdvanceSales: {},
    };
  },
  computed: {
    getGrandTotalNew() {
      console.log(this.$store.getters.grandTotalForConcessionsReport);
      return this.$store.getters.grandTotalForConcessionsReport;
    },
    ...mapGetters([
      // GET LIST ONLY
      "getPosUsersList",
      "getPaymentTypesList",
      "getCinemasList",
      "getDailyConcessionReportList",
      // Flags
      "getDailyReportsIsCinema",
      "getDailyReportsIsExcelDownload",
      // Rendered List
      "getDailyReportList",
      "getDailyRefundList",
      // Selected Dates
      "getDailyReportToDate",
      "getDailyReportFromDate",
      // Selected Dropdowns
      "getDailyReportSelectedPaymentMode",
      "getDailyReportSelectedPosUser",
      "getDailyReportSelectedCinema",
      "getDailyReportSelectedCinemaId",
      // FILEs
      "getDailyExcelFileName",
      // PSD
      "getDailyPDFFileName",
      // GET TOTALs
      "getGrandTotal",
      "getBoxOfficeTotal",
      "getConcessionOfficeTotal",
      "getPaymentSummary",
      "getFilmSummary",
      "getUserWiseSummary",
      "getCashRefundVoucher",
      "getSaleCashCard",
      "getTopUpCashCard",
      "getRefundSummary",
      "getConcessionDailyReportData",
      "grandTotalForConcessionsReport",
      "getConcessionDailyExcelFileName",
      "getConcessionDailyPdfFileName",
    ]),
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onDailyReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
        });
      }
    },
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    // this.onDailyReportFlagHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: cinemaId
    // });
    // this.fetchCinemasList({ cinemaId });
    // this.fetchPosUsersList();
    this.getCinemaList(cinemaId);
    this.fetchPaymentTypesList();

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onDailyReportDropdownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj,
      });
    }
  },
  mounted() { },
  methods: {
    moment,
    // refundedTotal() {
    //   refundedarr = getPaymentSummary.map((x) => {
    //     return x.refundAmount;
    //   });
    //   console.log(refundedarr, "refundedarr");
    // },

    showCardList(item) {
      this.showCardListNew = [];
      this.showCardListNew = item.cashCardDetails;
      // this.showCardListNew = item.cards.split(",");
      console.log(this.showCardListNew);
      this.$bvModal.show("cardDetails");
    },
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    setLabel(event) {
      if (event.first_name && event.first_name.length > 0) {
        return `${event.first_name ? event.first_name : ""} ${event.middle_name ? event.middle_name : ""
          } ${event.last_name ? event.last_name : ""}`;
      } else {
        return "All";
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name
              .toLowerCase()
              .includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onFetchReport() {
      this.fetchDailyReportListv2();
      // this.onFetchDailyConcessionReport();
      this.getDailyconcessionData("N");
      this.getAdvanceSales();
      this.getTodaysAdvanceSales();
      // this.getAddonsData();
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            // this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                // this.onDailyReportFlagHandler({
                // event: null,
                // name: "isCinema",
                // value: x.cine_id,
                // cine_name: x.cine_name
                // });
                this.onDailyReportDropdownHandler({
                  name: "Cinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  },
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getAddonsData: function (isPdf = "N") {
      let payload = {
        cinema_id: this.getDailyReportSelectedCinemaId
          ? this.getDailyReportSelectedCinemaId
          : 1,
        fromDate: this.getDailyReportFromDate,
        toDate: this.getDailyReportToDate,
        isPdf: isPdf,
      };
      this.addonsArray = [];
      ReportsServiceV2.getaddonsArray(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("dataNew", data);
            if (data.Records && data.Records.length > 0) {
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.addonsArray = data.Records;
              // this.addonsArrayTotal = this.addonsArray.total_quantity;
              // this.addonsArrayTotalArray = this.addonsArray.reduce(function(
              //   acc,
              //   {addonsArrayTotal}
              // ) {
              //   return acc + parseFloat(addonsArrayTotal);
              // },
              // 0);
              console.log("dataNew123", data.Records);
              // loader.hide();
            }
          } else {
            this.$toasted.show(data.message);
            // loader.hide();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          // this.$toasted.show(data.error);
        });
    },
    getDailyconcessionData: function (isPdf = "N") {
      let payload = {
        cinema_id: this.getDailyReportSelectedCinemaId
          ? this.getDailyReportSelectedCinemaId
          : 1,
        fromDate: this.getDailyReportFromDate,
        toDate: this.getDailyReportToDate,
        isPdf: isPdf,
      };
      this.getDailyconcessionDataArray = [];
      this.getDailyConcessionGrandTotal = {};
      let loader = this.$loading.show();
      ReportsServiceV2.GetdailySalesRecordsConcessionV2(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("dataNew", data);
            if (data.Records && data.Records.length > 0) {
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.getDailyconcessionDataArray = data.Records;
              this.getDailyConcessionGrandTotal = data.GrandTotal;
              console.log("dataNew123", data.Records);
              loader.hide();
            }
          } else {
            this.$toasted.show(data.message);
            loader.hide();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          // this.$toasted.show(data.error);
        });
      // .finally(() => {
      //   setTimeout(() => {
      //     loader.hide();
      //   }, 100);
      // });
    },
    getAdvanceSales: function (isPdf = "N") {
      let payload = {
        cinema_id: this.getDailyReportSelectedCinemaId
          ? this.getDailyReportSelectedCinemaId
          : 1,
        fromDate: this.getDailyReportFromDate,
        toDate: this.getDailyReportToDate,
        isPdf: isPdf,
      };
      this.getAdvanceSalesRecords = [];
      this.getAdvanceSalesHeaders = {};
      // let loader = this.$loading.show();
      ReportsServiceV2.GetdailySalesAdvanceRecords(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("dataNew", data);
            if (data.Records && data.Records.length > 0) {
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.getAdvanceSalesRecords = data.Records;
              this.getAdvanceSalesHeaders = data.paymentTypes;
              this.grandTotalAdvanceSales = data.grandTotalObj;
              // loader.hide();
            }
          } else {
            this.$toasted.show(data.message);
            // loader.hide();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          // this.$toasted.show(data.error);
        });
      // .finally(() => {
      //   setTimeout(() => {
      //     loader.hide();
      //   }, 100);
      // });
    },
    getTodaysAdvanceSales: function (isPdf = "N") {
      let payload = {
        cinema_id: this.getDailyReportSelectedCinemaId
          ? this.getDailyReportSelectedCinemaId
          : 1,
        fromDate: this.getDailyReportFromDate,
        toDate: this.getDailyReportToDate,
        isPdf: isPdf,
      };
      this.getTodaysAdvanceSalesRecords = [];
      // let loader = this.$loading.show();
      ReportsServiceV2.GetTodaysSalesAdvanceRecords(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("dataNew", data);
            if (data.Records && data.Records.length > 0) {
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.getTodaysAdvanceSalesRecords = data.Records;
              // loader.hide();
            }
          } else {
            this.$toasted.show(data.message);
            // loader.hide();
          }
        })
        .catch((error) => {
          console.log("Error:", error);
          // this.$toasted.show(data.error);
        });
      // .finally(() => {
      //   setTimeout(() => {
      //     loader.hide();
      //   }, 100);
      // });
    },
    //     getDailyReportV2() {
    // ReportsServiceV2.GetDailyReportList().then((result)=>{

    // })
    //     },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      "fetchPosUsersList",
      "fetchPaymentTypesList",

      // FETCH LIST ONLY
      "fetchDailyReportListv2",
      "onDailyReportDateHandler",
      "onDailyReportDropdownHandler",
      "onDailyReportFlagHandler",
      // "onFetchDailyConcessionReport",
      // ON RESET ALL
      "onResetDailyReportStoreState",
    ]),
  },
  beforeDestroy: async function () {
    console.log("getDailyExcelFileName :", this.getDailyExcelFileName);
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyExcelFileName,
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getDailyPDFFileName,
    });
    await this.onResetDailyReportStoreState();
  },
};
</script>

<style>
/* .align-last-center tr>th:last-child, tr>td:last-child {
  text-align: center;
}

.align-first-left tr > th:first-child,
tr > td:first-child {
  text-align: left;
  padding-left: 2px;
}

.align-last-right tr > th:last-child,
tr > td:last-child {
  text-align: right;
  padding-right: 2px;
} */

.fixed-layout-table {
  width: 100%;
  table-layout: fixed;
  white-space: normal;
}

.dailysales_report>tbody>tr>td {
  border: 1px dotted black;
}

.dailysales_report>tbody {
  border-bottom: 2px solid black;
}

.dailysales_report {
  zoom: 0.9;
  white-space: normal !important;
}

.table-elements-border>thead>tr>th:not(:last-child),
.table-elements-border>tbody>tr>td:not(:last-child) {
  border-right: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/dailySalesReport-v3.vue